import { t } from '../../../i18n/translate.js';

var profileMap = {
  OWNER: 'MPLIB_CONTACT_LIST_ROLE_OWNER',
  ADMIN: 'MPLIB_CONTACT_LIST_ROLE_ADMIN',
  LIMITED: 'MPLIB_CONTACT_LIST_ROLE_RESTRICTED',
  MINIMUM: 'MPLIB_CONTACT_LIST_ROLE_MINIMUM',
  NONE: 'MPLIB_CONTACT_LIST_ROLE_NONE'
};
var getUserProfile = function getUserProfile(user) {
  var pendingProfile = user.pendingInviteProfile;
  var profile = pendingProfile ? profileMap[user.pendingInviteProfile] : profileMap[user.profile];
  return profile;
};
var getProfileDescription = function getProfileDescription(user) {
  var pendingProfile = user.pendingInviteProfile;
  var description = pendingProfile ? "".concat(t(profileMap[user.pendingInviteProfile]), " (").concat(t('MPLIB_CONTACT_LIST_PENDING'), ")") : t(profileMap[user.profile]);
  return description;
};

export { getProfileDescription, getUserProfile, profileMap };
